import React, { useState } from 'react';
import { FaHome, FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { GuestFeedback } from './GuestFeedback'; // Make sure this path is correct

const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const [showFeedback, setShowFeedback] = useState(false);

  // Get data from local storage
  const checkoutData = JSON.parse(localStorage.getItem('checkoutData'));
  const orderDetails = JSON.parse(localStorage.getItem('orderDetails'));
  const hotelPropertyCache = JSON.parse(localStorage.getItem('hotelPropertyCache'));

  // Extract guest details from the stored data
  const guestDetails = {
    guestName: `${checkoutData?.primary_guest?.firstname || ''} ${
      checkoutData?.primary_guest?.lastname || ''
    }`.trim(),
    guestEmail: checkoutData?.primary_guest?.emailid || '',
    hotelName: hotelPropertyCache?.data?.propertyname || 'Our Hotel',
    orderId: checkoutData?.orderid || orderDetails?.orderid || '',
  };

  const steps = [
    {
      id: 1,
      title: 'Verify Details',
      description: 'Please verify the details of your stay',
      number: 1,
    },
    {
      id: 2,
      title: 'Payment',
      description: 'Complete your checkout payment',
      number: 2,
    },
    {
      id: 3,
      title: 'Checkout Complete',
      description: '',
      number: 3,
    },
  ];

  const currentStep = 3; // Since this is the success page

  const handleBackToHome = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/');
  };

  const handleOpenFeedback = () => {
    setShowFeedback(true);
  };

  const handleCloseFeedback = () => {
    setShowFeedback(false);
  };

  return (
    <div className="min-h-screen bg-white p-4 mt-16 md:p-6">
      <div className="mx-auto bg-white rounded-lg border border-gray-200 overflow-hidden w-full">
        {/* Progress Steps */}
        <div className="p-4 border-b border-gray-200 bg-gray-50">
          <div className="flex justify-between relative">
            {steps.map((step, index) => (
              <div
                key={step.id}
                className="flex flex-col items-center z-10"
                style={{ width: `${100 / steps.length}%` }}
              >
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${
                    currentStep >= step.id ? 'border-black bg-black' : 'border-gray-300 bg-gray-100'
                  }`}
                >
                  <span
                    className={`text-lg font-medium ${
                      currentStep >= step.id ? 'text-white' : 'text-gray-500'
                    }`}
                  >
                    {step.number}
                  </span>
                </div>
                <span
                  className={`text-sm mt-1 text-center font-medium ${
                    currentStep >= step.id ? 'text-black' : 'text-gray-500'
                  }`}
                >
                  {step.title}
                </span>
              </div>
            ))}
            <div className="absolute top-5 left-10 right-10 h-1 bg-gray-200">
              <div
                className="h-1 bg-black transition-all duration-300"
                style={{
                  width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
                }}
              ></div>
            </div>
          </div>
        </div>

        {/* Success Content */}
        <div className="p-4 md:p-6">
          <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-sm p-6">
            {/* Success Header */}
            <div className="text-center mb-8">
              <FaCheckCircle className="text-green-500 text-7xl mx-auto mb-2" />
              <h1 className="text-2xl font-bold mb-1">Check-Out Complete</h1>
              <p className="text-lg">
                Thank you for staying at {guestDetails.hotelName},{' '}
                {guestDetails.guestName.split(' ')[0]}!
              </p>
            </div>

            {/* Receipt Section */}
            <div className="mb-4 rounded-lg border border-gray-200 bg-white shadow-sm p-5 max-w-md mx-auto">
              <h2 className="text-lg font-semibold text-blue-800 mb-2">We’ve Sent Your Invoice!</h2>
              <p className="text-gray-600">
                A copy of the invoice have been sent to your email: <br />
                <span className="font-medium text-blue-600">{guestDetails.guestEmail}</span>
              </p>
            </div>

            {/* Key Handover Section */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6">
              <h3 className="font-bold mb-2">Key Handover</h3>
              <p className="text-gray-600 mb-4">
                Thank you! Your checkout is now complete. Please ensure you have returned your room
                keys at the front desk. We hope you had a pleasant stay!
              </p>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={handleBackToHome}
                className="flex-1 bg-black text-white py-3 px-4 rounded-lg font-medium hover:bg-gray-800 transition-colors flex items-center justify-center gap-2"
              >
                <FaHome />
                Return to Home Screen
              </button>
              <button
                onClick={handleOpenFeedback}
                className="flex-1 bg-black text-white py-3 px-4 rounded-lg font-medium hover:bg-gray-800 transition-colors flex items-center justify-center gap-2"
              >
                Provide Feedback
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Feedback Modal */}
      {showFeedback && (
        <GuestFeedback
          onClose={handleCloseFeedback}
          orderId={guestDetails.orderId}
          guestName={guestDetails.guestName}
          guestEmail={guestDetails.guestEmail}
        />
      )}
    </div>
  );
};

export default CheckoutSuccess;

// import React, { useState } from "react";
// import { FaHome, FaCheckCircle, FaUserAlt } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { GuestFeedback } from "./GuestFeedback"; // Make sure this path is correct

// const CheckoutSuccess = () => {
//   const navigate = useNavigate();
//   const [showFeedback, setShowFeedback] = useState(false);

//   // Get data from local storage
//   const checkoutData = JSON.parse(localStorage.getItem("checkoutData"));
//   const orderDetails = JSON.parse(localStorage.getItem("orderDetails"));
//   const hotelPropertyCache = JSON.parse(
//     localStorage.getItem("hotelPropertyCache")
//   );

//   // Extract guest details from the stored data
//   const guestDetails = {
//     guestName: `${checkoutData?.primary_guest?.firstname || ""} ${
//       checkoutData?.primary_guest?.lastname || ""
//     }`.trim(),
//     guestEmail: checkoutData?.primary_guest?.emailid || "",
//     hotelName: hotelPropertyCache?.data?.propertyname || "Our Hotel",
//     orderId: checkoutData?.orderid || orderDetails?.orderid || "",
//   };

//   const steps = [
//     {
//       id: 1,
//       title: "Verify Details",
//       description: "Please verify the details of your stay",
//       icon: FaUserAlt,
//     },
//     {
//       id: 2,
//       title: "Payment",
//       description: "Complete your checkout payment",
//       icon: FaCheckCircle,
//     },
//     {
//       id: 3,
//       title: "Checkout Complete",
//       description: "",
//       icon: FaCheckCircle,
//     },
//   ];

//   const currentStep = 3; // Since this is the success page

//   const handleBackToHome = () => {
//     localStorage.clear();
//     sessionStorage.clear();
//     navigate("/");
//   };

//   const handleOpenFeedback = () => {
//     setShowFeedback(true);
//   };

//   const handleCloseFeedback = () => {
//     setShowFeedback(false);
//   };

//   return (
//     <div className="min-h-screen bg-white p-4 mt-16 md:p-6">
//       <div className="mx-auto bg-white rounded-lg border border-gray-200 overflow-hidden w-full">
//         {/* Progress Steps */}
//         <div className="p-4 border-b border-gray-200 bg-gray-50">
//           <div className="flex justify-between relative">
//             {steps.map((step, index) => (
//               <div
//                 key={step.id}
//                 className="flex flex-col items-center z-10"
//                 style={{ width: `${100 / steps.length}%` }}
//               >
//                 <div
//                   className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${
//                     currentStep >= step.id
//                       ? "border-black bg-white"
//                       : "border-gray-300 bg-gray-100"
//                   }`}
//                 >
//                   <step.icon
//                     className={`text-sm ${
//                       currentStep >= step.id ? "text-black" : "text-gray-500"
//                     }`}
//                   />
//                 </div>
//                 <span
//                   className={`text-xs mt-1 text-center font-medium ${
//                     currentStep >= step.id ? "text-black" : "text-gray-500"
//                   }`}
//                 >
//                   {step.title}
//                 </span>
//               </div>
//             ))}
//             <div className="absolute top-5 left-10 right-10 h-1 bg-gray-200">
//               <div
//                 className="h-1 bg-black transition-all duration-300"
//                 style={{
//                   width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
//                 }}
//               ></div>
//             </div>
//           </div>
//         </div>

//         {/* Success Content */}
//         <div className="p-4 md:p-6">
//           <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-sm p-6">
//             {/* Success Header */}
//             <div className="text-center mb-8">
//               <FaCheckCircle className="text-green-500 text-7xl mx-auto mb-2" />
//               <h1 className="text-2xl font-bold mb-1">Check-Out Complete</h1>
//               <p className="text-lg">
//                 Thank you for staying at {guestDetails.hotelName},{" "}
//                 {guestDetails.guestName.split(" ")[0]}!
//               </p>
//             </div>

//             {/* Receipt Section */}
//             <div className="mb-4 rounded-lg border border-gray-200 bg-white shadow-sm p-5 max-w-md mx-auto">
//               <h2 className="text-lg font-semibold text-blue-800 mb-2">
//                 Your Receipt
//               </h2>
//               <p className="text-gray-600">
//                 A copy has been sent to your email: <br />
//                 <span className="font-medium text-blue-600">
//                   {guestDetails.guestEmail}
//                 </span>
//               </p>
//             </div>

//             {/* Key Handover Section */}
//             <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6">
//               <h3 className="font-bold mb-2">Key Handover</h3>
//               <p className="text-gray-600 mb-4">
//                 Thank you! Your checkout is now complete. Please ensure you have
//                 returned your room keys at the front desk. We hope you had a
//                 pleasant stay!
//               </p>
//             </div>

//             {/* Action Buttons */}
//             <div className="flex flex-col sm:flex-row gap-4">
//               <button
//                 onClick={handleBackToHome}
//                 className="flex-1 bg-black text-white py-3 px-4 rounded-lg font-medium hover:bg-gray-800 transition-colors flex items-center justify-center gap-2"
//               >
//                 <FaHome />
//                 Return to Home Screen
//               </button>
//               <button
//                 onClick={handleOpenFeedback}
//                 className="flex-1 bg-black text-white py-3 px-4 rounded-lg font-medium hover:bg-gray-800 transition-colors flex items-center justify-center gap-2"
//               >
//                 Provide Feedback
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Feedback Modal */}
//       {showFeedback && (
//         <GuestFeedback
//           onClose={handleCloseFeedback}
//           orderId={guestDetails.orderId}
//           guestName={guestDetails.guestName}
//           guestEmail={guestDetails.guestEmail}
//         />
//       )}
//     </div>
//   );
// };

// export default CheckoutSuccess;
